"use client";
import Image from "next/image";
import { StaticImageData } from "next/image";
import CertificateExampleImg from "@/public/bg-images/example-certificate-verified.webp";
import useTranslations from "@/i18n/useTranslations";

interface Props {
  sideRailImage?: { imageUrl?: string; altDescription?: string };
}

type SideRailImageProps = {
  imageSrc?: string | StaticImageData;
  altDescription?: string;
  width?: number;
  height?: number;
};

export default function SideRailImage({
  sideRailImage,
  imageSrc = CertificateExampleImg,
  altDescription,
  height = 243,
  width = 243,
}: Props & SideRailImageProps) {
  const t = useTranslations("Common");
  const defaultAlt = altDescription ?? t("certificateImage");
  const { imageUrl: img = imageSrc, altDescription: alt = defaultAlt } =
    sideRailImage || {};
  return (
    <div>
      <Image
        src={img}
        alt={alt ?? defaultAlt}
        className={`w-full h-[${height}px] border-2 border-putty-100`}
        width={width}
        height={height}
      />
    </div>
  );
}
